var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.groundFloors.length === 0 && _vm.actionType === "view"
        ? _c("div", { staticStyle: { "margin-top": "40px" } }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("NoVerticalPlanning")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.groundFloors.length === 0 &&
      _vm.undergroundFloors.length === 0 &&
      !_vm.dialogIsOpen &&
      _vm.actionType !== "view"
        ? _c(
            "v-btn",
            {
              staticClass: "structure-button",
              staticStyle: { "margin-top": "40px" },
              on: {
                click: function($event) {
                  _vm.dialogIsOpen = true
                }
              }
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("DefineBuildingStructure")) + "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.groundFloors.length > 0 || _vm.undergroundFloors.length > 0,
              expression:
                "groundFloors.length > 0 || undergroundFloors.length > 0"
            }
          ],
          key: _vm.buildingKey,
          staticClass: "form tab-content",
          staticStyle: { "flex-wrap": "nowrap" }
        },
        [
          _c("building", {
            staticClass: "building",
            attrs: {
              "ground-floors": _vm.groundFloors,
              "underground-floors": _vm.undergroundFloors,
              columns: _vm.columns,
              "selected-floorbox": _vm.selectedFloorbox,
              "selected-object": _vm.selectedObject,
              "action-type": _vm.actionType
            },
            on: {
              "add-column": _vm.addColumn,
              "add-ground-floor": function($event) {
                return _vm.addFloor(_vm.groundFloors.length, "ground")
              },
              "add-underground-floor": function($event) {
                return _vm.addFloor(
                  -1 - _vm.undergroundFloors.length,
                  "underground"
                )
              },
              "select-column": function($event) {
                return _vm.selectColumn($event)
              },
              "select-floorbox": function($event) {
                return _vm.selectFloorbox($event.floorbox)
              },
              "swap-floorbox": function($event) {
                return _vm.swapFloorbox(
                  $event.columnIndex,
                  $event.floorboxIndex
                )
              },
              "select-floor": function($event) {
                return _vm.selectFloor($event.floorIndex, $event.floorType)
              },
              "select-fraction": function($event) {
                return _vm.selectFraction(
                  $event.floorIndex,
                  $event.floorType,
                  $event.fractionIndex
                )
              },
              "connect-all-fractions": function($event) {
                return _vm.connectAllFractions(
                  $event.floorIndex,
                  $event.floorType
                )
              }
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "vertical-splitter",
            style: { height: _vm.dividerHeight + "px" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column" },
            [
              _c("vertical-structure-buttons", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.selectedObject.data,
                    expression: "!selectedObject.data"
                  }
                ],
                attrs: {
                  columns: _vm.columns.length,
                  "underground-floors": _vm.undergroundFloors.length,
                  "ground-floors": _vm.groundFloors.length
                },
                on: {
                  "add-column": _vm.addColumn,
                  "delete-column": _vm.deleteColumn,
                  "add-underground-floor": _vm.addFloor,
                  "add-ground-floor": _vm.addFloor,
                  "delete-floor": _vm.deleteFloor
                }
              }),
              _vm._v(" "),
              _c("technical-locals-table", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.selectedObject.data,
                    expression: "!selectedObject.data"
                  }
                ],
                attrs: {
                  "tecnical-table-is-open": _vm.tecnicalTableIsOpen,
                  "action-type": _vm.actionType,
                  "technical-locals": _vm.technicalLocals
                },
                on: {
                  "open-tecnical-local-form": _vm.openTecnicalLocalForm,
                  "open-edit-tecnical-local": _vm.openEditTecnicalLocal,
                  "delete-tecnical-local": _vm.deleteTecnicalLocal,
                  "open-and-close-tecnical-local-table": function($event) {
                    _vm.tecnicalTableIsOpen = !_vm.tecnicalTableIsOpen
                  }
                }
              }),
              _vm._v(" "),
              _vm.selectedObject.type !== "Column"
                ? _c("fractions-table", {
                    attrs: {
                      "ground-floors": _vm.groundFloors,
                      "underground-floors": _vm.undergroundFloors,
                      fractions: _vm.getAllFractions(),
                      "fractions-table-is-open": _vm.fractionsTableIsOpen,
                      "selected-object": _vm.selectedObject,
                      cableTypeFiveOptions: _vm.cableTypeFiveOptions
                    },
                    on: {
                      "select-fraction": function($event) {
                        return _vm.selectTableItem(
                          $event.floorIndex,
                          $event.floorType,
                          $event.fractionIndex
                        )
                      },
                      "create-fraction": function($event) {
                        return _vm.createFraction($event)
                      },
                      "save-fraction": function($event) {
                        return _vm.saveFraction($event.data)
                      },
                      "delete-fraction": function($event) {
                        return _vm.deleteFloorFraction($event)
                      },
                      "open-and-close-fractions-table": function($event) {
                        _vm.fractionsTableIsOpen = !_vm.fractionsTableIsOpen
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("floorboxes-table", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedObject.data,
                    expression: "selectedObject.data"
                  }
                ],
                staticStyle: { "min-width": "25%" },
                attrs: {
                  "selected-object": _vm.selectedObject,
                  "floorbox-colors": _vm.availableFloorboxColors,
                  "action-type": _vm.actionType,
                  "ground-floors": _vm.groundFloors,
                  "underground-floors": _vm.undergroundFloors,
                  columns: _vm.columns,
                  "technical-locals": _vm.technicalLocals,
                  floorboxs: _vm.getFloorboxs(),
                  cableTypeSixOptions: _vm.cableTypeSixOptions,
                  cableTypeFiveOptions: _vm.cableTypeFiveOptions
                },
                on: {
                  "delete-column": function($event) {
                    return _vm.deleteColumn($event.columnIndex)
                  },
                  "delete-floor": function($event) {
                    return _vm.deleteFloor($event.floorIndex)
                  },
                  "delete-floorbox": function($event) {
                    return _vm.deleteFloorbox(
                      $event.columnUuid,
                      $event.floorboxLabel
                    )
                  },
                  "create-floorbox": function($event) {
                    return _vm.createFloorbox($event)
                  },
                  "save-floorbox": function($event) {
                    return _vm.saveFloorbox($event.data, $event.index)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("building-structure-dialog", {
        attrs: { "dialog-is-open": _vm.dialogIsOpen },
        on: {
          "close-dialog": _vm.closeDialog,
          "preview-building": function($event) {
            return _vm.previewBuilding($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.tecnicalLocalFormIsOpen
        ? _c("technical-local-form", {
            attrs: {
              "dialog-is-open": _vm.tecnicalLocalFormIsOpen,
              "item-to-edit": _vm.itemToEdit
            },
            on: {
              "add-tecnical-local": _vm.addTecnicalLocal,
              "edit-tecnical-local": _vm.editTecnicalLocal,
              "close-tecnical-local-form": _vm.closeTecnicalLocalForm
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bc55ed6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bc55ed6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/VerticalPlanning.vue
// module id = null
// module chunks = 